<template>
  <ProductPageLayout
    name="谷哥地球-天地图"
    :logo="logo"
    :hero-image="heroImage"
    lead="Windows 端三维地球客户端，基于天地图影像浏览全球与国内重点区域，支持中英文界面，本地流畅运行。"
    :feature-lines="featureLines"
    download-link="/ftp/packages/earthview/EarthViewSetup.exe"
    download-file-name="EarthViewSetup.exe"
    :meta-items="metaItems"
    :detailed-features="detailedFeatures"
    :other-features="otherFeatures"
    :reviews="reviews"
    features-desc="卫星实景浏览、地点定位与多语言界面，让地理信息查看更直观。"
    other-desc="面向学习、出行参考与地图浏览场景，操作简洁稳定。"
    reviews-desc="真实反馈持续驱动地球浏览体验优化。"
  />
</template>

<script>
import ProductPageLayout from '@/components/ProductPageLayout.vue'

export default {
  name: 'EarthView',
  components: { ProductPageLayout },
  data() {
    return {
      logo: require('@/assets/earthview/logo_48x48.png'),
      heroImage: require('@/assets/earthview/地球-天安门.png'),
      featureLines: [
        '三维地球浏览 / 天地图影像 / 地点定位',
        '中英文界面 / 平滑缩放 / 本地运行'
      ],
      metaItems: [
        { icon: 'image', label: '实景影像' },
        { icon: 'fast', label: '流畅缩放' },
        { icon: 'lock', label: '本地客户端' }
      ],
      detailedFeatures: [
        {
          title: '三维地球浏览',
          brief: '在 Windows 上直接旋转、缩放查看全球影像。',
          detail: '基于天地图能力构建桌面客户端，支持平滑缩放与视角切换，快速从全球视野落到城市街区。',
          image: require('@/assets/earthview/地球-中文.png')
        },
        {
          title: '国内重点区域',
          brief: '天安门等标志区域影像清晰可辨。',
          detail: '对国内主要城市与地标区域提供良好的浏览体验，适合地理认知、出行参考与教学演示。',
          image: require('@/assets/earthview/地球-天安门.png')
        },
        {
          title: '中英文界面',
          brief: '界面语言可切换，适配不同使用习惯。',
          detail: '提供中文与英文界面，兼顾国内用户与需要英文标注场景的浏览需求。',
          image: require('@/assets/earthview/地球-英文.png')
        },
        {
          title: '地标与航拍视角',
          brief: '长江大桥等标志建筑一览无余。',
          detail: '在三维地球中定位桥梁、城市与自然地貌，帮助用户建立空间感，浏览过程直观流畅。',
          image: require('@/assets/earthview/地球-长江大桥.png')
        }
      ],
      otherFeatures: [
        { title: '平滑缩放', description: '从全球到街区过渡自然，操作跟手。', icon: 'fast' },
        { title: '地点定位', description: '快速跳转到关注区域，减少反复拖拽。', icon: 'pin' },
        { title: '桌面客户端', description: '独立 Windows 应用，启动后即可浏览。', icon: 'image' },
        { title: '持续维护', description: '跟随系统与影像能力迭代，保持兼容稳定。', icon: 'iterate' }
      ],
      reviews: [
        { name: '刘老师', comment: '给学生演示地理区位很直观，缩放流畅，比网页版更专注。', avatar: require('@/assets/earthview/avatar1.jpg') },
        { name: '孙同学', comment: '看天安门和城市周边很清楚，做课前预习用地图更有感觉。', avatar: require('@/assets/earthview/avatar2.jpg') },
        { name: '马设计', comment: '中英文切换方便，找参考视角时不用来回开网页。', avatar: require('@/assets/earthview/avatar3.jpg') },
        { name: '高产品', comment: '本地客户端启动稳定，浏览大桥和城市区域体验不错。', avatar: require('@/assets/earthview/avatar4.jpg') },
        { name: '何运营', comment: '出差前扫一眼目的地周边，比纯平面地图更有空间感。', avatar: require('@/assets/earthview/avatar5.jpg') },
        { name: '罗工程', comment: '三维地球操作简单，办公电脑上也能顺畅使用。', avatar: require('@/assets/earthview/avatar6.jpg') }
      ]
    }
  }
}
</script>
